<template>
  <div class="wrap">
    <h1>{{data.title}}</h1>
    <div v-for="(item, index) in data.paragraph" :key="index" class="para-item">
      <h2 class="sub-title">{{item.subTitle}}</h2>
      <p v-if="item.subHeaderText" class="retract">{{item.subHeaderText}}</p>
      <div v-if="item.text">
        <div v-for="(items, i) in item.text" :key="i">
          <p class="three-title">{{items.threeTitle}}</p>
          <p v-if="items.threeHeaderText" class="three-text">{{items.threeHeaderText}}</p>
          <div v-if="items.subText" class="three-block">
            <div v-if="Array.isArray(items.subText) && items.subText.length>0">
              <div v-for="(subItem, ii) in items.subText" :key="ii">
                <h3 class="four-title">{{subItem.fourTitle}}</h3>
                <p v-if="subItem.fourHeaderText" class="four-retract">{{subItem.fourHeaderText}}</p>
                <div v-if="subItem.threeText">
                  <div v-for="(threeItem, iii) in subItem.threeText" :key="iii">
                    <p class="four-text">{{threeItem}}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-for="(subItem, ii) in items.subText" :key="ii">
                <p>{{subItem}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Agreement',
  props: {
    data: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
  .wrap {
    padding: 24px;
    overflow-y: scroll;
    height: 100%;
    -webkit-overflow-scrolling: touch;
  }

  h1 {
    text-align: center;
    font-family: '黑体';
    font-size: 40px;
  }

  .sub-title {
    margin-bottom: 1em;
  }

  .para-item {
    margin-bottom: 50px;
  }

  .retract {
    text-indent: 2em;
  }

  .three-title, .three-text, .three-block, .four-retract, .four-text, .four-title {
    margin-bottom: 0.5em;
  }

  .three-text, .four-text {
    text-indent: 2em;
  }

  h2, p, h3 {
    text-align: justify;
    font-size: 30px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 48px;
  }

  h2 {
    font-size: 36px !important;
    font-weight: bold;
  }
</style>
